export default __webpack_public_path__ + "static/media/empty-cart.c8864223.png";